export default (function (value) {
  return typeof Map !== 'undefined' && value instanceof Map;
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/isMap.js
// module id = OWFF
// module chunks = 0